module.exports = __webpack_public_path__ + "static/img/15203083561.aa7d117.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/15203083561.jpg
// module id = i02Y
// module chunks = 0